import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import useSignalTreatmentUsage from 'app/signals/application/useSignalTreatmentUsage'
import { Signal } from 'app/signals/types'

import { PageControls, Table } from 'components'

import styles from './TreatmentUsage.module.scss'

const TreatmentUsage = ({ signal }: { signal: Signal }) => {
  const { t } = useTranslation('signals')
  const [page, setPage] = useState(1)
  const pageSize = 5
  const { rows, loading, failed, totalPages } = useSignalTreatmentUsage(signal, page, pageSize)
  const number = new Intl.NumberFormat('de-DE')
  if (loading || failed || !rows.length)
    return (
      <p className={styles.message}>
        {t(`details.treatments.${loading ? 'loading' : failed ? 'failed' : 'empty'}`)}
      </p>
    )

  return (
    <div className={styles.usage}>
      <Table.Table
        className={styles.table}
        columns={[
          t('details.treatments.name'),
          t('details.treatments.clicks'),
          t('details.treatments.conversions'),
        ]}
        data={rows}
        renderRow={(row) => (
          <Table.Row key={row.id}>
            <Table.Cell>{row.name}</Table.Cell>
            <Table.Cell>{row.clicks === null ? '-' : number.format(row.clicks)}</Table.Cell>
            <Table.Cell>
              {row.conversions === null ? '-' : number.format(row.conversions)}
            </Table.Cell>
          </Table.Row>
        )}
      />
      <PageControls
        currentPage={page}
        onPageChange={setPage}
        totalPages={totalPages}
        fullSize={false}
      />
    </div>
  )
}

export default TreatmentUsage
